import { render, staticRenderFns } from "./HeroForm.vue?vue&type=template&id=a78d9922&scoped=true&"
import script from "./HeroForm.vue?vue&type=script&lang=js&"
export * from "./HeroForm.vue?vue&type=script&lang=js&"
import style0 from "./HeroForm.vue?vue&type=style&index=0&id=a78d9922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78d9922",
  null
  
)

export default component.exports